var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ggk"},[_c('img',{class:_vm.item.entryType == 1 ? 'absImg' : 'staImg',style:({'width': _vm.item.width}),attrs:{"src":_vm.item.entryImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }